var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"size":"small","fetch-suggestions":_vm.querySearchAsync,"disabled":_vm.disable,"placeholder":_vm.placeholder},on:{"select":_vm.handleChange,"input":_vm.handleInput,"blur":_vm.handleBlur},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"label",attrs:{"title":item.value}},[_vm._v(_vm._s(item.value)+" "),(item.child)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("(主)")]):_vm._e()])]}}]),model:{value:(_vm.customerIds),callback:function ($$v) {_vm.customerIds=$$v},expression:"customerIds"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13364caa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/CustomerSelect.vue
// module id = 1194
// module chunks = 0